import React, {useEffect} from "react";


import {NavLink, useSearchParams} from "react-router-dom";

import { Col, Row } from "react-bootstrap";

import SectionContainerComponent from "@Components/Sections/SectionContainer";

import { LinkComponent } from "@Components/Elements/TextElements";


import footerLogo from "@Assets/LogoWhite.png";

import "./index.scss";


type ApplicationFooterProps = {};


export const ApplicationFooter:React.FC<ApplicationFooterProps> = () => {

    const [searchParams, setSearchParams] = useSearchParams();

    const campaignType = searchParams.get('campaign');
    const campaignAffiliate = searchParams.get('cir');

    if (campaignType === 'lr' && campaignAffiliate) {
        localStorage.setItem('user_registration_affiliate', campaignAffiliate);
    }

    useEffect(() => {
        return () => {
            setSearchParams(undefined);
        };
    }, []);

    return (
        <SectionContainerComponent id={'app-footer'} as={'footer'}>

            <Col xs={12} lg={4} className={'app-footer__section app-footer__info'}>
                <Row className={'app-footer__section__content app-footer__info__content'}>
                    <Col xs={12} className={'app-footer__info__footer_logo'}>
                        <NavLink to={'/'} title={"Home Page"}>
                            <img src={footerLogo} alt={'Qyvo'}/>
                        </NavLink>
                    </Col>
                    <Col xs={12} className={'app-footer__info__company-motto'}>
                        <span>What you’re owed,<br/>on autopilot.</span>
                    </Col>
                    <Col xs={12} className={'app-footer__info__company-description'}>
                        <span>Automatic refunds from your inbox.<br/>Get money back without the hassle.</span>
                    </Col>
                </Row>
            </Col>

            <Col xs={6} lg={3} className={'app-footer__section app-footer__menu'}>
                <Row className={'app-footer__section__content app-footer__menu__content'}>
                    <Col xs={12} className={'app-footer__menu__content__header'}>
                        <span>Product</span>
                    </Col>
                    <Col xs={12} className={'app-footer__menu__content__navigation'}>
                        <Row className={'app-footer__menu__content__navigation__content'}>
                            <Col xs={12} className={'app-footer__menu__content__navigation__element'}>
                                <LinkComponent href={'/how-it-works'} text={'How It Works'} inverted={true} size={'s'} />
                            </Col>
                            <Col xs={12} className={'app-footer__menu__content__navigation__element'}>
                                <LinkComponent href={'/security'} text={'Security'} inverted={true} size={'s'} />
                            </Col>
                            <Col xs={12} className={'app-footer__menu__content__navigation__element'}>
                                <LinkComponent href={'/faq'} text={'FAQ'} inverted={true} size={'s'} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>

            <Col xs={6} lg={3} className={'app-footer__section app-footer__menu'}>
                <Row className={'app-footer__section__content app-footer__menu__content'}>
                    <Col xs={12} className={'app-footer__menu__content__header'}>
                        <span>Legal</span>
                    </Col>
                    <Col xs={12} className={'app-footer__menu__content__navigation'}>
                        <Row className={'app-footer__menu__content__navigation__content'}>
                            <Col xs={12} className={'app-footer__menu__content__navigation__element'}>
                                <LinkComponent href={'/privacy-policy'} text={'Privacy Policy'} inverted={true} size={'s'} />
                            </Col>
                            <Col xs={12} className={'app-footer__menu__content__navigation__element'}>
                                <LinkComponent href={'/terms-of-service'} text={'Terms of Service'} inverted={true} size={'s'} />
                            </Col>
                            <Col xs={12} className={'app-footer__menu__content__navigation__element'}>
                                <LinkComponent href={'/anti-harassment'} text={'Anti-Harassment and Discrimination'} inverted={true} size={'s'} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>

            <Col xs={6} lg={2} className={'app-footer__section app-footer__menu'}>
                <Row className={'app-footer__section__content app-footer__menu__content'}>
                    <Col xs={12} className={'app-footer__menu__content__header'}>
                        <span>Contact</span>
                    </Col>
                    <Col xs={12} className={'app-footer__menu__content__navigation'}>
                        <Row className={'app-footer__menu__content__navigation__content'}>
                            <Col xs={12} className={'app-footer__menu__content__navigation__element'}>
                                <LinkComponent href={'mailto:hello@useqyvo.com'} text={'hello@useqyvo.com'} inverted={true} size={'s'} />
                            </Col>
                            <Col xs={12} className={'app-footer__menu__content__navigation__element'}>
                                <LinkComponent href={'mailto:privacy@useqyvo.com'} text={'privacy@useqyvo.com'} inverted={true} size={'s'} />
                            </Col>
                            <Col xs={12} className={'app-footer__menu__content__navigation__element'}>
                                <LinkComponent href={'mailto:legal@useqyvo.com'} text={'legal@useqyvo.com'} inverted={true} size={'s'} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>

            <Col xs={12} className={'app-footer__copyrights'}>
                <span className={'app-footer__copyrights__text'}>© {(new Date()).getFullYear()} Qyvo. All rights reserved.</span>
            </Col>

        </SectionContainerComponent>
    );

};


export default ApplicationFooter;
